import React from 'react';
import './AboutSection.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faInstagram, faFacebook } from '@fortawesome/free-brands-svg-icons';
import { faHeadphones, faTruckFast, faMicrochip, faArrowUpRightFromSquare } from '@fortawesome/free-solid-svg-icons';

function AboutSection() {
    return (
        <section className="about-section" id="about">
            <div className="container about-shell">
                <div className="row g-4 align-items-stretch">
                    <div className="col-lg-7">
                        <div className="about-panel about-panel-social h-100">
                            <span className="about-social-chip">Canales oficiales</span>
                            <h3 className="about-social-title">Sigue la escena Vintage Pro</h3>
                            <p className="about-social-copy">
                                Novedades, pruebas y lanzamientos en nuestros canales oficiales.
                            </p>

                            <div className="about-social-deck">
                                <a
                                    href="https://www.instagram.com/vintageproaudiocolombia/"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className="about-social-btn about-social-btn-instagram"
                                    aria-label="Instagram Vintage Pro Audio"
                                >
                                    <span className="about-social-btn-top">
                                        <span className="about-social-btn-icon" aria-hidden="true">
                                            <FontAwesomeIcon icon={faInstagram} />
                                        </span>
                                        <span className="about-social-btn-kicker">Instagram Oficial</span>
                                    </span>
                                    <span className="about-social-btn-copy">
                                        <strong>Instagram</strong>
                                        <small>Reels y demos del catalogo</small>
                                    </span>
                                    <span className="about-social-btn-bottom">
                                        <span className="about-social-btn-state">Actividad diaria</span>
                                        <span className="about-social-btn-cta">
                                            Entrar
                                            <FontAwesomeIcon icon={faArrowUpRightFromSquare} className="about-social-btn-arrow" />
                                        </span>
                                    </span>
                                </a>

                                <a
                                    href="https://www.facebook.com/vintageproaudiocolombia"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className="about-social-btn about-social-btn-facebook"
                                    aria-label="Facebook Vintage Pro Audio"
                                >
                                    <span className="about-social-btn-top">
                                        <span className="about-social-btn-icon" aria-hidden="true">
                                            <FontAwesomeIcon icon={faFacebook} />
                                        </span>
                                        <span className="about-social-btn-kicker">Comunidad Facebook</span>
                                    </span>
                                    <span className="about-social-btn-copy">
                                        <strong>Facebook</strong>
                                        <small>Comunidad y anuncios de marca</small>
                                    </span>
                                    <span className="about-social-btn-bottom">
                                        <span className="about-social-btn-state">Respuestas activas</span>
                                        <span className="about-social-btn-cta">
                                            Entrar
                                            <FontAwesomeIcon icon={faArrowUpRightFromSquare} className="about-social-btn-arrow" />
                                        </span>
                                    </span>
                                </a>
                            </div>

                            <p className="about-social-note mb-0">Conecta con Vintage Pro en un clic.</p>
                        </div>
                    </div>

                    <div className="col-lg-5">
                        <div className="about-panel h-100">
                            <span className="about-kicker">VINTAGE PRO AUDIO COLOMBIA</span>
                            <h2 className="about-title">
                                Sonido profesional con criterio tecnico, historia y personalidad
                            </h2>
                            <p className="about-lead">
                                Equipos para estudio, directo, broadcast y produccion digital.
                            </p>
                            <p className="about-copy mb-0">
                                Desde Bogota, acompanamos a musicos y creadores con asesoria experta.
                            </p>

                            <div className="about-pill-grid mt-4">
                                <div className="about-pill">
                                    <FontAwesomeIcon icon={faHeadphones} />
                                    <span>Seleccion curada</span>
                                </div>
                                <div className="about-pill">
                                    <FontAwesomeIcon icon={faMicrochip} />
                                    <span>Asesoria experta</span>
                                </div>
                                <div className="about-pill">
                                    <FontAwesomeIcon icon={faTruckFast} />
                                    <span>Cobertura nacional</span>
                                </div>
                            </div>

                            <div className="about-metrics mt-4">
                                <div className="about-metric">
                                    <strong>Audio Pro</strong>
                                    <span>Foco 100% especializado</span>
                                </div>
                                <div className="about-metric">
                                    <strong>Soporte real</strong>
                                    <span>Antes, durante y despues de la compra</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
}

export default AboutSection;